import React from 'react';
import { styled } from '@this/constants/themes';

import { reportError } from '@this/lib/bugsnag';
import { StyledReserveWarningAlert, StyledAlertTitle } from '@this/components/shared/reserve_ui_components';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Link } from '@this/components/shared/ui/navigations/link';
import type Hotel from '@this/src/domain/hotel/hotel2';
import Text from '../../../shared/text/text';
import StayPlanWarning from '../../select/shared/stay_plan_warning';

type Props = {
  hotel: Hotel | null | undefined;
  isPackage: boolean;
};

const ReserveConfirmHotelTr: React.FC<Props> = ({ hotel, isPackage }) => {
  try {
    return hotel ? (
      <>
        <Text text={hotel.name} />
        <TextDetail>
          <span data-wovn-ignore>
            {hotel.checkinDate?.format('YYYY-MM-DD')} 〜 {hotel.checkoutDate?.format('YYYY-MM-DD')}
          </span>
          <br />
          {isPackage ? (
            `${hotel.peopleNum}名/${hotel.roomnum}室`
          ) : (
            <div className="flex">
              <span data-wovn-ignore>{utils.digits(hotel.totalPrice)}</span>円({hotel.peopleNum}名/{hotel.roomnum}
              室)
            </div>
          )}
          {hotel.mandatoryTax && hotel.mandatoryTax > 0 ? (
            <p data-wovn-ignore>{utils.digits(hotel.mandatoryTax)}円(現地徴収料)</p>
          ) : null}
          <p>
            {hotel.stayDays}泊{hotel.days}日
          </p>
          <p>チェックイン　：{hotel.checkinText}</p>
          <p>チェックアウト：{hotel.checkoutText}</p>
          <p>
            朝食：
            {hotel.breakfast == null ? 'お問合せください' : hotel.breakfast ? '有り' : '無し'}
          </p>
          <p>
            宿泊プラン：
            {hotel.planName || '-'}
          </p>
          {hotel.selectedPlanRestricted && (
            <StayPlanWarningWrapper>
              <StayPlanWarning variant="text" restricted={hotel.selectedPlanRestricted} />
            </StayPlanWarningWrapper>
          )}
          {hotel.detailPath && (
            <p>
              宿泊詳細情報：
              <Link href={hotel.detailPath} target="_blank" rel="noreferrer noopener">
                詳細はコチラ
              </Link>
            </p>
          )}
          {hotel.roomType && (
            <p>
              部屋タイプ：
              {hotel.roomType}
            </p>
          )}
          <p>ベッドタイプ：{hotel.displayBedType}</p>
          {hotel.hasMultipleBedTypes && (
            <div style={{ margin: '8px 0' }}>
              <StyledReserveWarningAlert icon={<ErrorOutlineIcon />} variant="filled" severity="error">
                <StyledAlertTitle>ベッドタイプについて</StyledAlertTitle>
                <div>
                  <p style={{ margin: '4px 0' }}>{hotel.bedTypeNoticeMessage}</p>
                </div>
              </StyledReserveWarningAlert>
            </div>
          )}
          {!isPackage && (
            <p>
              ホテルの返金：
              {hotel.refundable == null ? (
                'お問合せください'
              ) : hotel.refundable ? (
                '可'
              ) : (
                <ReserveConfirmCancelStatus>不可</ReserveConfirmCancelStatus>
              )}
            </p>
          )}
        </TextDetail>
        {hotel.averagePriceDetailArray.map((d, i) => (
          <PriceDetail key={i}>
            <p>{d.title}</p>
            <p>{d.price}</p>
          </PriceDetail>
        ))}
      </>
    ) : (
      <span>-</span>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

const PriceDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 100px;
`;

const ReserveConfirmCancelStatus = styled.span`
  font-weight: bold;
  color: #959595;
  padding: 6px 10px 10px 10px;
`;

const TextDetail = styled.div`
  font-size: 0.9em;
  padding-left: 0.9em;
  font-weight: normal;
`;

const StayPlanWarningWrapper = styled.div`
  margin: 2px 0;
`;

export default ReserveConfirmHotelTr;
